import { gsap } from 'gsap/dist/gsap';
import Scrollbar from 'smooth-scrollbar';
const mobileNav = () => {
  const openMobileNav = (e) => {
    e.preventDefault();
    if ($(window).width() < 500) {
      gsap.to($('.mobile-nav'), {
        right: '0px',
        width: '100%',
        overflow: 'auto',
        duration: '.2',
        display: 'block',
        ease: 'power4.out',
      });
    } else {
      gsap.to($('.mobile-nav'), {
        right: '0',
        duration: '.2',
        ease: 'power4.out',
      });
    }
  };
  const closeMobileNav = (e) => {
    e.preventDefault();
    $('.mobile-nav__levelMenu').removeClass('mobile-nav__levelMenu--open');
    $('.mobile-nav').removeClass('mobile-nav--open');
    $('.mega').css('display', 'none');
    $('.mega__wrap').css('display', 'none');
    $('.mega__inside').css('opacity', '0');
    if ($(window).width() < 500) {
      gsap.to($('.mobile-nav'), {
        right: '-100%',
        width: '100%',
        duration: '.2',
        display: 'none',
        ease: 'power4.out',
      });
    } else {
      gsap.to($('.mobile-nav'), {
        right: '-420px',
        duration: '.2',
        ease: 'power4.out',
      });
    }
  };

  const openLevelTwo = (e) => {
    e.preventDefault();
    gsap.to($('.third-ul'), {
      display: 'none',
      height: 'auto',
      duration: '0',
      ease: 'power4.out',
    });
    gsap.to($(e.target).siblings('.third-ul'), {
      display: 'block',
      height: 'auto',
      duration: '.3',
      ease: 'power4.out',
    });
    $('.mobe-minus').hide();
    $('.mobe-plus').show();
    $(e.target).closest('.mobe-plus').hide();
    $(e.target).siblings('.mobe-minus').show();
  };
  const closeLevelTwo = (e) => {
    e.preventDefault();
    $('.mobe-plus').show();
    gsap.to($(e.target).siblings('.third-ul'), {
      display: 'none',
      height: '0',
      duration: '.3',
      ease: 'power4.out',
    });
    $(e.target).siblings('.mobe-plus').show();
    $(e.target).closest('.mobe-minus').hide();
  };

  $(() => {
    $('.mobe-minus').hide();
    $('.mobe-plus').show();
    $('.mobile-nav').hide();
    $('.mobe-plus').on('click', openLevelTwo);
    $('.mobe-minus').on('click', closeLevelTwo);

    // Open mobile nav functions
    $('.hamburger').on('click', openMobileNav);
    $('.hamburger').on('click', function () {
      $('.mobile-nav').show();
      Scrollbar.destroyAll();
    });

    // close mobile nav functions
    $('.close-mobile').on('click', closeMobileNav);
    $('.close-mobile').on('click', function () {
      $('.mobile-nav').hide();
    });
  });
};

export default mobileNav;
